// extracted by mini-css-extract-plugin
export var addressFields = "_ok-0";
export var animationContainer = "_ok-1";
export var footer = "_ok-2";
export var lineItems = "_ok-3";
export var modalContent = "_ok-4";
export var orderName = "_ok-5";
export var strong = "_ok-6";
export var warning = "_ok-7";